import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import "./style.scss";
import { GrClose } from "react-icons/gr";
import "../../style/block.scss";
import "../../style/buttons.scss";
import { Assort } from "../../app/models/Assort";
import { t } from "i18next";
import { TicketAccess } from "../../app/models/TicketAccess";
import TicketLineSummary from "../../app/components/Universal/TicketLineSummary";
import PreBasketSummary from "../../app/components/Universal/PreBasketSummary";
import usePreBasket from "../../app/components/Universal/hooks/usePreBasket";
import useBasketManager from "../../app/components/FinalizePage/hooks/useBasketManager";
import { BasketItem } from "../../app/models/BasketItem";
import { Exercise } from "../../app/models/Exercise";
import LoadableComponent from "../Loading/LoadableComponent";
import useCalculatePreBasketQnt from "../../app/components/Universal/hooks/useCalculatePreBasketQnt";
import EAIconButton from "../../app/components/shared/Buttons/EAIconButton";
import EAButton from "../../app/components/shared/Buttons/EAButton";
import useParentMessage from "../../utils/hooks/useParentMessage";
import useEAModalIframeScrolling from "../../app/components/shared/Modal/useEAModalIframeScrolling";

interface IProps {
  footer: boolean;
  open: boolean;
  afterOpenModal?: () => void;
  closeModal: () => void;
  styles?: any;
  children: any;
  title: string;
  leftType?: string;
  leftImage?: string;
  leftTitle?: string;
  leftText?: string;
  acceptText?: string;
  cancelText?: string;
  ticketLists?: Assort[];
  exercise?: Exercise;
  onAccept: () => void;
  ticketAccess?: TicketAccess;
  loading?: boolean;
  disabledAccept?: boolean;
}

const ModalComponent: React.FC<IProps> = ({
  footer,
  open,
  afterOpenModal = () => {},
  closeModal,
  styles,
  children,
  title,
  leftType,
  leftTitle,
  leftText,
  leftImage,
  ticketLists,
  acceptText = t("akceptuj"),
  cancelText = t("anuluj"),
  ticketAccess,
  onAccept,
  exercise,
  loading = false,
  disabledAccept = false,
}: IProps) => {
  const { getBasket } = useBasketManager();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const [limit, setLimit] = useState(0);
  const modalRef = useRef<HTMLDivElement>(null);
  const { qntState } = useCalculatePreBasketQnt(preBasket);

  const handleDeleteBasket = () => {
    clearBasket();

    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    // scrollToCenter();
    if (exercise) {
      setLimit(exercise.capacity - (exercise.prereservation + exercise.reserved));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exercise]);

  const ticketsInCurrentBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);

  const { modalTop } = useEAModalIframeScrolling(modalRef);
  const { updateScrollPosition } = useParentMessage();

  useEffect(() => {
    if (open) {
      // Daj czas na wyrenderowanie DOM przed wysłaniem request
      requestAnimationFrame(() => {
        updateScrollPosition();
      });
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
    //eslint-disable-next-line
  }, [open]);

  if (!open) return null;

  return (
    <Modal
      id="modal-1"
      isOpen={open}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      contentLabel="modal"
      className="modal-container shadow"
    >
      <div
        className="eamodal-exercise-container"
        ref={modalRef}
        style={{
          position: "absolute",
          top: modalTop,
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <LoadableComponent loading={loading}>
          {leftImage && (
            <>
              {leftType === "exercise" && (
                <div className="left-modal">
                  <div className="exercise-picture" style={{ backgroundImage: `url(${leftImage})` }}>
                    <b>{leftTitle}</b>
                  </div>
                </div>
              )}
            </>
          )}

          {leftType === "pass" && (
            <div className="left-modal ">
              <div className="pass-type">
                <span>{t("szczegoly_karnetu")}</span>
                {leftImage && <div className="exercise-picture" style={{ backgroundImage: `url(${leftImage})` }}></div>}
                <b className="pass-type-title">{leftTitle}</b>
                {leftText && (
                  <article className="text-description" dangerouslySetInnerHTML={{ __html: leftText }}></article>
                )}
              </div>
            </div>
          )}

          {leftType === "news" && (
            <div className="left-modal ">
              <div className="pass-type">
                <div className="exercise-picture" style={{ backgroundImage: `url(${leftImage})` }}></div>
              </div>
            </div>
          )}

          <div
            className={
              !leftImage && leftType === "exercise" ? "full-right-modal right-modal" : "right-modal border-right"
            }
          >
            <div className="title">
              <h2>{title}</h2>
              <EAIconButton title="Zamknij" variant="icon" onClick={closeModal} icon={<GrClose />} />
            </div>
            <div className="content-right">{children}</div>

            {footer && (
              <div className="flex-end-center modal-footer">
                <EAButton title={cancelText} onClick={closeModal} variant="outlined" />
                <EAButton title={acceptText} onClick={onAccept} disabled={disabledAccept} />
              </div>
            )}
          </div>
          {ticketLists && exercise && (
            <div className="tickets">
              <div className={"calendar-sale-ticket"}>
                <div className="tickets-list-group">
                  {ticketLists.map((itemTicket, index) => (
                    <div className={"ticket-block"} key={index}>
                      {/* <TicketLine item={itemTicket} exercise={ticketAccess} /> */}
                      <TicketLineSummary
                        item={itemTicket}
                        exercise={ticketAccess}
                        preBasket={preBasket}
                        addItemToBasket={addItemToBasket}
                        removeItemFromBasket={removeItemFromBasket}
                        ticketLimit={limit}
                        qntState={qntState}
                      />
                    </div>
                  ))}
                </div>

                {limit === ticketsInCurrentBasket() && (
                  <div className="flex-between-center alert alert-red ">
                    <b>{t("nie_mozesz_dodac_wiekszej_ilosci_biletow_do_koszyka")}</b>
                  </div>
                )}
                <PreBasketSummary
                  ticketLimit={limit}
                  preBasket={preBasket}
                  clearBasket={handleDeleteBasket}
                  eventDate={exercise.startTime}
                />
                {/* <TicketLine item={item} exercise={ticketAccess} /> */}
              </div>
            </div>
          )}
        </LoadableComponent>
      </div>
    </Modal>
  );
};
Modal.setAppElement("#root");

export default ModalComponent;
